angular
  .module('app.components')
  .controller('TechEdgeNotificationController', TechEdgeNotification);

TechEdgeNotification.$inject = [
  'close',
  'campaign',
  'ModalService',
  'CampaignManagerService',
];

function TechEdgeNotification(
  close,
  campaign,
  ModalService,
  CampaignManagerService,
) {
  const vm = this;
  vm.hideWarning = false;

  vm.onCreateSnapshot = () => {
    close(false, 0);

    ModalService.showModal({
      templateUrl: `/assets/js/app/components/techEdge/techEdge.modal.html?v=${window.BUILD_VERSION}`,
      controller: 'TechEdgeModalController',
      controllerAs: 'techEdgeModal',
      inputs: {
        addSnapshot: false,
        saveFromModal: true,
        targetCampaign: campaign,
      }
    }).then(modal => {
      modal.element.modal();
      modal.close.then(result => {
        $('.modal-backdrop.fade.in').remove();
      });
    });
  };

  vm.onToggleWarning = () => {
    vm.hideWarning = !vm.hideWarning;

    const keyStorage = `hideTechedgeNotification${campaign.pid}`;
    localStorage.setItem(keyStorage, vm.hideWarning);
  };

  vm.onIgnore = () => {
    CampaignManagerService.hideTechedgeNotification();
    close(false, 0);
  };

  vm.onClose = () => close(false, 0);
}
